// extracted by mini-css-extract-plugin
module.exports = {"BackDrop":"Modal_BackDrop__1Wpli","fadein":"Modal_fadein__1D8kr","Modal":"Modal_Modal__2WBTT","X":"Modal_X__2bqC-","desc":"Modal_desc__1GShh"};